import React from 'react';

const Footer = () => {
  return (
    <div className="w-full flex items-center justify-center border-t border-gray-400 py-2 px-2 md:px-12">
      <div className="w-full max-w-screen-xl text-sm text-gray-800 text-center md:text-left font-medium">
        <div>Created with &#x2764; and &#x2728; by Emmanuel Ezeka</div>
      </div>
    </div>
  )
}

export default Footer